module.exports = __webpack_public_path__ + "img/exclamation-mark.8430b993.svg";